// AI Generated Test
import { Component, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'form-global-policy-pre-content-rule-without-context',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    template: `
        <div class="mt-4 mx-4" ngModelGroup="ruleWithoutContext">
            <div class="row">
                <div class="col-24 col-md-30">
                    <div class="card panel-monsido-card">
                        <div class="card-header">
                            <h4 class="font-weight-300" translate>Policy setup</h4>
                        </div>
                        <div class="card-body">
                            <div class="row pb-2" *ngFor="let row of ngModel; let i = index; trackBy: trackByIndex">
                                <div class="col-48 col-md-19">
                                    <div class="form-group row mb-0">
                                        <label [attr.for]="'policy-pre-content-inputfield-word-' + i"
                                               class="col-sm-16 col-form-label text-bold text-right capitalize-first-letter">
                                            <span translate>Word</span>
                                            <span>*</span>
                                        </label>
                                        <div class="col-sm-32">
                                            <input [(ngModel)]="row.word"
                                                   name="word_{{i}}"
                                                   type="text"
                                                   class="form-control"
                                                   [attr.id]="'policy-pre-content-inputfield-word-' + i"
                                                   placeholder="{{ 'insert word fx. contact' | translate }}"
                                                   (ngModelChange)="onModelChange()"
                                                   required
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-48 col-md-22">
                                    <div class="form-group row mb-0">
                                        <label [attr.for]="'policy-pre-content-inputfield-context-' + i"
                                               class="col-sm-16 col-form-label text-bold text-right capitalize-first-letter">
                                            <span translate>Context</span>
                                            <span>*</span>
                                        </label>
                                        <div class="col-32">
                                            <input [(ngModel)]="row.context"
                                                   name="context_{{i}}"
                                                   type="text"
                                                   class="form-control"
                                                   [attr.id]="'policy-pre-content-inputfield-context-' + i"
                                                   placeholder="{{ 'insert context fx. us' | translate }}"
                                                   (ngModelChange)="onModelChange()"
                                                   required
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-48 col-md-7">
                                    <a class="btn btn-border-radius btn-secondary"
                                       (click)="removeRow(row)">
                                        <span class="fas fa-trash-alt" aria-hidden="true"></span>
                                    </a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-40 offset-sm-6">
                                    <a class="btn btn-border-radius btn-secondary outer-l-mini" (click)="addRow()">
                                        <span class="fas fa-plus" aria-hidden="true"></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-24 col-md-18">
                    <div class="card panel-monsido-card">
                        <div class="card-header">
                            <h4 class="font-weight-300" translate>
                                Information
                            </h4>
                        </div>
                        <div class="card-body">
                            <p>
                                <strong translate>How to setup this policy</strong>
                            </p>
                            <p translate>Find word(s) without specific context</p>
                            <p>fx. <code translate>contact</code> <span translate>should always be followed by</span> <code translate>us</code></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
    standalone: false,
})
export class FormGlobalPolicyPreContentRuleWithoutContextComponent {
    @Input() model: any;
    ngModel: any = [{ word: '', context: '' }];

    trackByIndex (index: number, item: any): number {
        return index;
    }

    onModelChange () {
        const rules: any = [];
        this.ngModel.forEach((row: any) => {
            rules.push({
                name: 'Find word: ' + row.word + ' not followed by context: ' + row.context,
                case_sensitive: true,
                inverse: false,
                operator: 'regex',
                query: row.word + '\\s(?!' + row.context + ')',
                type: 'page_text',
                sub_entry: '',
            });
        });
        this.model = rules;
    }

    addRow () {
        this.ngModel.push({ word: '', context: '' });
    }

    removeRow (row: any) {
        const index = this.ngModel.indexOf(row);
        if (index !== -1) {
            this.ngModel.splice(index, 1);
        }
    }
}
